<template>
  <div class="container-page">
    <div class="list-of-users">
      <!-- title -->
      <p class="list-of-users__title title-inner">Список уведомляемых пользователей</p>
      <template v-if="isAccessAllowed">
        <!-- search -->
        <div class="list-of-users__search">
          <div class="list-of-users__search-container">
            <div class="list-of-users__search-inputBlock">
              <p>Поиск</p>
              <input placeholder="ФИО" type="text" v-model="searchName" @keyup.enter="search(true)" />
              <IconComponent name="search2" @click="search(true)" />
            </div>
          </div>
        </div>
        <div class="mb-16" v-if="Object.keys(changedItemBag).length">
          <ButtonComponent buttonType="button" mod="gradient-bg" class="mr-2" @click="saveNotifications()"
            >Сохранить</ButtonComponent
          >
          <ButtonComponent buttonType="button" mod="blue-color" @click="resetNotifications()">Сбросить</ButtonComponent>
        </div>
        <!-- table -->
        <div v-if="page.items">
          <div class="list-of-users__table table-container js-table-arrow">
            <table class="stockTable">
              <thead>
                <tr>
                  <th rowspan="2">ФИО</th>
                  <th rowspan="2">Адрес электронной почты</th>
                  <th colspan="3">Уведомления</th>
                </tr>
                <tr>
                  <th>Системные</th>
                  <th>По электронной почте</th>
                  <th>Push</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in page.items" :key="item.id">
                  <td>{{ item.fullName }}</td>
                  <td>{{ item.user?.email }}</td>
                  <template v-if="item.user">
                    <td class="checkboxInput">
                      <CheckboxInput
                        :id="`System${item.id}`"
                        v-model="item.user.notifyBySystemMessages"
                        @update:modelValue="changeNotification(item)"
                      />
                    </td>
                    <td class="checkboxInput">
                      <CheckboxInput
                        :id="`Email${item.id}`"
                        v-model="item.user.notifyByEmail"
                        @update:modelValue="changeNotification(item)"
                      />
                    </td>
                    <td class="checkboxInput">
                      <CheckboxInput
                        :id="`Push${item.id}`"
                        v-model="item.user.notifyByPush"
                        @update:modelValue="changeNotification(item)"
                      />
                    </td>
                  </template>
                  <template v-else>
                    <td></td>
                    <td></td>
                    <td></td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="page.pagesTotal > 1">
            <Pagination
              :pageCount="page.pagesTotal"
              :currentPage="page.pageNumber"
              @change="onPageChange($event, false)"
              @more="onPageChange($event, true)"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  // Additional
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import API from '../api/users';

  const PERMISSIONS = {
    view: Constants.Permissions.UserNotificationView,
    edit: Constants.Permissions.UserNotificationEdit,
  };

  export default {
    name: 'UserNotifications',
    components: {
      IconComponent,
      CheckboxInput,
      ButtonComponent,
    },
    mixins: [security],
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        searchName: '',
        filter: {
          fullName: '',
          sortOrder: '1',
        },
        changedItemBag: {},
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.loadPage();
    },
    methods: {
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      loadPage(addToExist) {
        const request = Object.assign(this.filter, this.request);
        API.searchNotifications(request).then((response) => {
          if (!addToExist) {
            this.page = {};
            this.$nextTick(() => {
              this.page = response.data;
            });
          } else if (response.data) {
            //добавляем к существующему
            this.page.pageNumber = response.data.pageNumber;
            this.page.items = this.page.items.concat(response.data.items);
          }
          this.$nextTick(() => {
            this.page.items.forEach((x) => {
              if (x.user && this.changedItemBag[x.user.id]) {
                x.user.notifyByEmail = this.changedItemBag[x.user.id].notifyByEmail;
                x.user.notifyByPush = this.changedItemBag[x.user.id].notifyByPush;
                x.user.notifyBySystemMessages = this.changedItemBag[x.user.id].notifyBySystemMessages;
              }
            });
          });
        });
      },
      search(isNameChange) {
        if (isNameChange) this.filter.fullName = this.searchName;
        this.request.pageNumber = 1;
        this.loadPage(false);
      },
      changeNotification(item) {
        this.changedItemBag[item.user.id] = {
          notifyByEmail: item.user.notifyByEmail,
          notifyByPush: item.user.notifyByPush,
          notifyBySystemMessages: item.user.notifyBySystemMessages,
        };
      },
      resetNotifications() {
        this.changedItemBag = {};
        this.loadPage(false);
      },
      saveNotifications() {
        API.saveNotifications(this.changedItemBag)
          .then(() => {
            Constants.alert.fire('Сохранение', 'Настройки уведомлений сохранены', 'success');
            this.request.pageNumber = 1;
            this.resetNotifications();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', 'Не удалось сохранить настройки.', 'error');
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .icon {
    color: $green;
  }

  .list-of-users {
    padding-bottom: 80px;
    &__search {
      &-container {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        padding-bottom: 32px;
        margin-bottom: 32px;
        border-bottom: 1px dashed #d7d7d7;
      }
      &-inputBlock {
        position: relative;
        width: 100%;
        input {
          width: 50%;
          padding: 8px 21px;
          border-radius: 5px;
        }
        .icon {
          position: absolute;
          bottom: 12px;
          right: calc(50% + 12px);
        }
        p {
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: 0.15px;
          color: #343c44;
          margin-bottom: 8px;
        }
      }
    }
    &__table {
      table {
        thead {
          th {
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            color: #3b4d3e;
            padding: 16px;
            border-bottom: 1px solid #787f8f;
          }
          tr {
            &:nth-of-type(1) {
              th {
                &:nth-of-type(1) {
                  width: 40%;
                  border-right: 1px solid #787f8f;
                }
                &:nth-of-type(2) {
                  width: 40%;
                  border-right: 1px solid #787f8f;
                }
                &:nth-of-type(3) {
                  text-align: center;
                  width: 20%;
                }
              }
            }
            &:nth-of-type(2) {
              th {
                &:nth-of-type(1),
                &:nth-of-type(2) {
                  width: 10%;
                  border-right: 1px solid #787f8f;
                }
                &:nth-of-type(3) {
                  width: 10%;
                }
              }
            }
          }
        }
        tbody {
          tr {
            border-bottom: 1px solid #787f8f;
          }
          td {
            padding: 16px;
            font-size: 14px;
            line-height: 150%;
            color: #3b4d3e;
            &:not(:last-child) {
              border-right: 1px solid #787f8f;
            }
          }
        }
        .table-statusBlock {
          display: flex;
          p {
            margin-right: auto;
            margin-bottom: 0px;
          }
        }
      }
    }
  }
</style>
